// =============================================================================
// SIREPPAR - Contador del partido: novedades de la SEP que todavía no vio
// =============================================================================
// Cuenta las consultas de la agrupación activa en las que la SEP inició la
// consulta o respondió y el partido todavía no la abrió. Cerrar sin responder no
// cuenta. Se refresca solo cada minuto y, además, al abrir una consulta o
// contestarla (las pantallas invalidan la clave).
// =============================================================================

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { consultaService } from '../services/api';
import { puedeUsarConsultas } from '../utils/consultas';

export const CLAVE_PENDIENTES_PARTIDO = ['consultas-pendientes-partido'];

export function useConsultasPendientesPartido(): number {
  const { user } = useAuth();
  const habilitado = puedeUsarConsultas(user?.rol);
  const { data } = useQuery({
    // Con la agrupación en la clave: al cambiar de agrupación activa se vuelve a contar.
    queryKey: [...CLAVE_PENDIENTES_PARTIDO, user?.partidoId],
    queryFn: () => consultaService.pendientes(),
    enabled: habilitado,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
  return data?.data?.cantidad ?? 0;
}
